export function isNull<TValue>(value: TValue | null): value is null {
	return value === null;
}
